import styled from 'styled-components';

const GrantedPermissionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 25px 0;
`;

const GrantedPermissionItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

const GrantedPermissionTitle = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 15px;
`;

const IconContainer = styled.div`
  width: 18px;
  height: 18px;
  margin-right: 10px;
`;

const PermissionButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-left: 30px;
`;

const ConnectOptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const OrDivider = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme?.palette?.text?.secondary || '#888'};
  white-space: nowrap;
`;

export {
  GrantedPermissionsContainer,
  GrantedPermissionItem,
  GrantedPermissionTitle,
  IconContainer,
  PermissionButtonContainer,
  ConnectOptionsRow,
  OrDivider,
};
